import StaticImage from './Staticimage';

export default StaticImage;
